import baseUrlPath from "./baseUrlPath";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const StartQuizQApi = createApi({
    reducerPath: "startQuizQApi",
    baseQuery:fetchBaseQuery({
        baseUrl:baseUrlPath.test+"/startquiz/"
    }),
    tagTypes:["startquiz"],
    endpoints:(builder) => ({
        startNewQuiz:builder.mutation({
            query:(quizData) =>({
                url:"NewQuiz",
                method:"POST",
                headers:{
                    "content-type":"application/json",
                },
                body:quizData,
            }),
            invalidatesTags:["startquiz"]
        }),
         validateQuiz:builder.mutation({
            query:(answers) =>({
                url:"validate-quiz",
                method:"POST",
                headers:{
                    "content-type":"application/json",
                },
              
                body:answers,
            }),
            invalidatesTags:["startquiz"]
        }),
        getCurrentQuizList: builder.query({
            query: (userId) => ({
                url: "get-current-quiz",
                params: {
                    userId
                }, 
            }),
            providesTags: ["startquiz"],
        }),


    }),
});

export const {
useStartNewQuizMutation,
useGetCurrentQuizListQuery,
useValidateQuizMutation,
} = StartQuizQApi;